import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    class: "p-generate",
    id: "scrollable-element"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", {
    id: "userId",
    "data-user-id": "1"
}, null, -1);
const _hoisted_3 = { class: "p-generate__parent" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
    id: "myModal",
    class: "c-modalSelect"
};
const _hoisted_6 = { class: "c-modalSelect__content" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("p", { class: "c-modalSelect__title" }, "選択範囲を編集する", -1);
const _hoisted_8 = { class: "c-modalSelect__list" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
    class: "p-generateAi--change",
    id: "js-generate-modal",
    style: { "z-index": "00" }
};
const _hoisted_11 = { class: "p-generateAi__overflowY u-mgBottom--10" };
const _hoisted_12 = { class: "p-generateBtn__wrapper c-modalSticky u-display--flex u-flex-align-center u-flex-justify-center" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", { class: "fa-solid fa-rotate-left" }, null, -1);
const _hoisted_14 = ["disabled"];
const _hoisted_15 = { class: "u-display--flex u-flex-align-center u-flex-justify-center" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("div", {
    id: "stringCount",
    style: { "display": "none" }
}, null, -1);
const _hoisted_17 = { class: "p-topBtns--border p-generateBtns" };
const _hoisted_18 = { class: "p-topBtns__count--bgNone p-generateBtn__count u-mgRight--10" };
const _hoisted_19 = {
    id: "form",
    method: "POST",
    "data-url": "{{ route('get_time') }}"
};
const _hoisted_20 = { class: "p-generateBtns__btns" };
const _hoisted_21 = ["src"];
const _hoisted_22 = ["src"];
const _hoisted_23 = ["src"];
const _hoisted_24 = ["src"];
const _hoisted_25 = {
    key: 0,
    class: "fa-solid fa-spinner",
    style: { "margin-right": "1rem" }
};
const _hoisted_26 = ["src"];
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("button", {
    type: "button",
    id: "stop-speech",
    style: { "display": "none" },
    class: "p-topBtns__btn--footerNav"
}, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa-solid fa-volume-xmark" }),
    /*#__PURE__*/ _createTextVNode(" 止める ")
], -1);
const _hoisted_28 = ["src"];
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("div", { class: "buffer" }, null, -1);
import { ref, onMounted } from 'vue';
import { pasteTextAndFormat, manageAIModalPosition, manageCustomPlaceholders, cleartInputText, copyToClipboard, addNewLines, generateSpeech, multiLineCount, setupFullSelectionCopyFix, } from '../utils/helper';
import { streamChatCompletion, flattenDivs } from '../utils/helper';
import { useFontChanger } from '../composables/useFontChanger';
import Modal from '../components/generate/Modal.vue';
import ArrangeModal from '../components/generate/ArrangeModal.vue';
import AiProcessingIndicator from '../components/generate/AiProcessingIndicator.vue';
import { useGenerate } from '../composables/useGenerate';
import { useTextLength } from '../composables/useTextLength';
const initeText = `<div><p class="placeholder" style="display: block;">
■文章を作ってもらうとき<br>
下の「文章生成」ボタンを押して、キーワードなどを入力しましょう。<br>
AIがキーワードをもとに文章生成を実行します。<br><br>
■文章のアレンジ<br>文章を貼り付けるか、AIが作った文章をマウスで選択すると編集メニューが表示されます。<br>
文章全体をアレンジする場合は、下の「アレンジ」ボタンを押して、プルダウンから選択しましょう。<br>
プルダウンにない場合は、アレンジ内容をフリー入力できます。<br>生成・アレンジした文章を校正する際は、下の「この内容を校正する」ボタンを押してください。<br><br>
※校正モードへ切り替えたい場合は、上部の「校正・校閲」をクリックしてください。
</p></div>`;
export default /*#__PURE__*/ _defineComponent({
    __name: 'GeneratePage',
    props: {
        topUrl: {},
        prompts: {},
        lintServerUrl: {},
        lintServerPort: {},
        clientId: {},
        user: {}
    },
    setup(__props) {
        const props = __props;
        window.addEventListener('beforeunload', function (e) {
            e.preventDefault();
            e.returnValue = '';
            return "ページを離れようとしています。本当に離れますか？";
        });
        const lintBaseUrl = props.lintServerPort ? props.lintServerUrl + ':' + props.lintServerPort : props.lintServerUrl;
        const { changeFont } = useFontChanger();
        const { textLength, maxTextLength, textCounterClass, setTextLength, } = useTextLength(props.user.max_text_limit);
        const { initModal, arrangeModal, writeText, isGeneratePending, isGenerateModalOpen, generatedText, isSelecting, selectedText, selectedRange, selectedPrompt, openInitModal, closeInitModal, openArrangeModal, closeArrangeModal, setPromptModal, closePromptModal, openGenerateModal, completeGenerate, closeGenerateModal, handleMouseUp, } = useGenerate();
        const updateText = (text) => {
            const inputArea = document.getElementById('text');
            inputArea.innerHTML = text;
            textLength.value = inputArea.innerText.length;
            addNewLines('text');
        };
        onMounted(() => {
            const scrollable = document.getElementById('scrollable-element');
            manageCustomPlaceholders('.p-generate__inner', 'placeholder', 'data-placeholder');
            const textArea = document.getElementById('text');
            textArea?.addEventListener('input', function () {
                //常に行数を表示する為、空文字の場合はdivを挿入
                if (textArea.innerHTML.trim() === '' || textArea.innerHTML.trim() === '<br>' || textArea.innerHTML.trim() === '<br><br>') {
                    textArea.innerHTML = '<div></div>';
                }
                // 追加でモーダルを表示する高さ分の行数を追加
                addNewLines('text');
            });
            textArea?.addEventListener('paste', (event) => {
                pasteTextAndFormat(event, textArea);
                // 追加でモーダルを表示する高さ分の行数を追加
                addNewLines('text');
                setTextLength('text');
            });
            // textArea?.addEventListener('input',() => resetTextAreaOnEmptyInput(textArea));
            textArea?.addEventListener('selectstart', function () {
                closePromptModal();
                closeGenerateModal();
            });
            let isTextAreaSelecting = false;
            textArea?.addEventListener('mousedown', () => isTextAreaSelecting = true);
            window.addEventListener('mouseup', () => {
                if (isTextAreaSelecting) {
                    handleMouseUp(scrollable, 'myModal');
                    isTextAreaSelecting = false;
                }
            });
            textArea?.addEventListener('keyup', (event) => setTextLength('text'));
            setupFullSelectionCopyFix('text');
            // speechManager('text','start-speech','stop-speech');
        });
        const generateTextByPrompt = async (prompt) => {
            const scrollable = document.getElementById('scrollable-element');
            const range = selectedRange.value?.getBoundingClientRect();
            window.getSelection()?.removeAllRanges();
            window.getSelection()?.addRange(selectedRange.value);
            if (selectedText.value === '' || !range)
                return;
            selectedPrompt.value = prompt;
            const modal = document.getElementById('js-generate-modal');
            manageAIModalPosition(scrollable, modal, range);
            openGenerateModal();
            isSelecting.value = false;
            await postGenerate();
        };
        const stopSignal = new AbortController();
        const postGenerate = async () => {
            generatedText.value = '';
            isGeneratePending.value = true;
            const url = lintBaseUrl + '/gpt/adjust';
            const body = {
                text: selectedText.value,
                type: selectedPrompt.value,
                model: 'gpt-5-search-api',
                clientId: props.clientId,
            };
            const generator = streamChatCompletion(url, body, stopSignal.signal);
            for await (const text of generator) {
                generatedText.value = generatedText.value + text;
            }
            completeGenerate();
        };
        const replaceSelectedText = () => {
            const editor = document.getElementById('text');
            if (!editor) {
                return;
            }
            const range = selectedRange.value;
            if (!range) {
                return;
            }
            // 選択範囲内の最初のノードを取得
            let startNode = undefined;
            const nodes = editor.childNodes;
            for (const node of nodes) {
                if (node.contains(range.startContainer.parentNode)) {
                    startNode = node;
                    break;
                }
            }
            if (!startNode) {
                return;
            }
            // 選択範囲内を削除
            range.deleteContents();
            let insertText = '';
            if (selectedPrompt.value === 4) {
                console.log(selectedText.value);
                insertText = selectedText.value + generatedText.value;
            }
            else {
                insertText = generatedText.value;
            }
            // 生成テキストの改行ごとに分割（句点・ピリオドでは分割しない。空行もそのまま1要素として保持する）
            const replaceText = insertText.split(/\r\n|\r|\n/);
            const textToInsertNode = (startText, afterText) => {
                // 最初の行には開始ノードの選択範囲外のテキストを、最後の行には終了ノードの選択範囲外のテキストを結合する
                const temp = replaceText.map((text, index) => index === 0 ? startText + text : text);
                temp[temp.length - 1] += afterText;
                // 開始ノードの後ろにノードを追加していくので最後の文章からループ
                for (const text of temp.reverse()) {
                    // テキストのdiv要素を作成
                    const elem = document.createElement('div');
                    // 空行はブラウザのinnerText/コピー時に改行として認識されるよう<br>を明示的に入れる
                    if (text === '') {
                        elem.innerHTML = '<br>';
                    }
                    else {
                        elem.innerText = text;
                    }
                    // 開始ノードの後ろに追加
                    startNode.after(elem);
                }
            };
            // 選択したテキストが複数行かどうか
            const lineCount = multiLineCount(selectedText.value);
            if (lineCount > 1) {
                // 選択範囲を削除したあとに、開始ノードの次のノード（選択範囲の最終ノード）を取得
                const nextNode = startNode?.nextElementSibling;
                textToInsertNode(startNode.innerText, nextNode?.innerText || '');
                // 開始ノードを削除
                startNode.remove();
                // 終了ノードを削除
                nextNode?.remove();
            }
            else {
                // 選択範囲の開始前テキスト取得
                const before = startNode.innerText.slice(0, range.startOffset);
                // 選択範囲の終了後テキスト取得
                const after = startNode.innerText.slice(range.endOffset);
                textToInsertNode(before, after);
                // 開始ノードを削除
                startNode.remove();
            }
            flattenDivs(editor);
            addNewLines('text');
            closeGenerateModal();
        };
        const toProofPage = () => {
            const text = document.getElementById('text');
            if (!text)
                return;
            // const formmated = text.innerHTML;
            sessionStorage.setItem('generate_text', text.innerHTML);
            location.href = props.topUrl;
        };
        const speechPending = ref(false);
        let currentAudioIndex = 0;
        let isStopped = false;
        let currentAudio = null;
        // 読み上げボタンをクリックした時の処理
        const handleSpeech = () => {
            const textArea = document.getElementById('text');
            const startSpeechBtn = document.getElementById('start-speech');
            const stopSpeechBtn = document.getElementById('stop-speech');
            const apiBaseUrl = lintBaseUrl;
            const userId = props.user.id;
            const clientId = props.clientId;
            if (textArea && startSpeechBtn && stopSpeechBtn) {
                generateSpeech(textArea, startSpeechBtn, stopSpeechBtn, maxTextLength, apiBaseUrl, userId, clientId, speechPending, currentAudioIndex, isStopped, currentAudio);
            }
            else {
                console.error("textArea, startSpeechBtn, stopSpeechBtnが取得できませんでした");
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", {
                            style: { "background-color": "rgb(254, 254, 210)", "color": "black" },
                            innerHTML: _unref(writeText),
                            class: "p-generate__inner js-editable",
                            id: "text",
                            name: "text",
                            contenteditable: "true",
                            "data-placeholder": "■文章を作ってもらうとき<br>下の「文章生成」ボタンを押して、キーワードなどを入力しましょう。<br>AIがキーワードをもとに文章生成を実行します。<br><br>■文章のアレンジ<br>文章を貼り付けるか、AIが作った文章をマウスで選択すると編集メニューが表示されます。<br>文章全体をアレンジする場合は、下の「アレンジ」ボタンを押して、プルダウンから選択しましょう。<br>プルダウンにない場合は、アレンジ内容をフリー入力できます。<br>生成・アレンジした文章を校正する際は、下の「この内容を校正する」ボタンを押してください。<br><br>※校正モードへ切り替えたい場合は、上部の「校正・校閲」をクリックしてください。"
                        }, null, 8, _hoisted_4),
                        _withDirectives(_createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _createElementVNode("ul", _hoisted_8, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prompts, (prompt) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            class: "c-modalSelect__items",
                                            onClick: ($event) => (generateTextByPrompt(prompt.id))
                                        }, [
                                            _createElementVNode("span", null, _toDisplayString(prompt.view), 1)
                                        ], 8, _hoisted_9));
                                    }), 256))
                                ])
                            ])
                        ], 512), [
                            [_vShow, _unref(isSelecting)]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", null, [
                                _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(generatedText)), 1),
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "p-topBtns__btn",
                                        id: "js-text-clear",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (postGenerate()))
                                    }, [
                                        _hoisted_13,
                                        _createTextVNode(" やり直す ")
                                    ]),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "p-topBtns__btn",
                                        id: "js-text-clear",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (_unref(closeGenerateModal)()))
                                    }, " キャンセル "),
                                    _createElementVNode("button", {
                                        type: "submit",
                                        class: "c-btn--reflect",
                                        onClick: replaceSelectedText,
                                        disabled: _unref(isGeneratePending)
                                    }, "この内容で置き換える", 8, _hoisted_14)
                                ]),
                                _withDirectives(_createElementVNode("div", _hoisted_15, [
                                    _createVNode(AiProcessingIndicator)
                                ], 512), [
                                    [_vShow, _unref(isGeneratePending)]
                                ])
                            ])
                        ], 512), [
                            [_vShow, _unref(isGenerateModalOpen)]
                        ])
                    ]),
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("span", {
                                class: _normalizeClass(["js-count", _unref(textCounterClass)])
                            }, _toDisplayString(_unref(textLength)) + " / " + _toDisplayString(_unref(maxTextLength)) + "文字", 3)
                        ]),
                        _createElementVNode("form", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "p-topBtns__btn--footerNav",
                                        id: "js-modalGenerate",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (_unref(openInitModal)()))
                                    }, [
                                        _createElementVNode("img", {
                                            src: props.topUrl + '/images/common/icon/icon_02.svg',
                                            alt: "",
                                            class: "p-topBtns__btnIcon"
                                        }, null, 8, _hoisted_21),
                                        _createTextVNode(" 文章生成 ")
                                    ])
                                ]),
                                _createElementVNode("div", null, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "p-topBtns__btn--footerNav",
                                        id: "js-copy",
                                        onClick: _cache[3] || (_cache[3] = ($event) => (_unref(copyToClipboard)('text')))
                                    }, [
                                        _createElementVNode("img", {
                                            src: props.topUrl + '/images/common/icon/icon_07.svg',
                                            alt: "",
                                            class: "p-topBtns__btnIcon"
                                        }, null, 8, _hoisted_22),
                                        _createTextVNode(" コピー ")
                                    ])
                                ]),
                                _createElementVNode("div", null, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "p-topBtns__btn--footerNav",
                                        id: "js-text-clear",
                                        onClick: _cache[4] || (_cache[4] = () => {
                                            textLength.value = 0;
                                            _unref(cleartInputText)('text', initeText);
                                        })
                                    }, [
                                        _createElementVNode("img", {
                                            src: props.topUrl + '/images/common/icon/icon_08.svg',
                                            alt: "",
                                            class: "p-topBtns__btnIcon"
                                        }, null, 8, _hoisted_23),
                                        _createTextVNode(" クリア ")
                                    ])
                                ]),
                                _createElementVNode("div", null, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "p-topBtns__btn--footerNav",
                                        id: "js-preview",
                                        onClick: _cache[5] || (_cache[5] = ($event) => (_unref(openArrangeModal)()))
                                    }, [
                                        _createElementVNode("img", {
                                            src: props.topUrl + '/images/common/icon/icon_09.svg',
                                            alt: "",
                                            class: "p-topBtns__btnIcon"
                                        }, null, 8, _hoisted_24),
                                        _createTextVNode(" アレンジ ")
                                    ])
                                ]),
                                _createElementVNode("div", null, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "p-topBtns__btn--footerNav",
                                        id: "start-speech",
                                        onClick: handleSpeech
                                    }, [
                                        (speechPending.value)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_25))
                                            : (_openBlock(), _createElementBlock("img", {
                                                key: 1,
                                                src: props.topUrl + '/images/common/icon/icon_10.svg',
                                                alt: "",
                                                class: "p-topBtns__btnIcon"
                                            }, null, 8, _hoisted_26)),
                                        _createTextVNode(" 読み上げ ")
                                    ]),
                                    _hoisted_27
                                ]),
                                _createElementVNode("div", null, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "p-topBtns__btn--footerNavGold02",
                                        onClick: toProofPage
                                    }, [
                                        _createElementVNode("img", {
                                            src: props.topUrl + '/images/common/icon/icon_01.svg',
                                            alt: "",
                                            class: "p-topBtns__btnIcon"
                                        }, null, 8, _hoisted_28),
                                        _createTextVNode(" この内容を校正する ")
                                    ])
                                ])
                            ])
                        ])
                    ])
                ]),
                _withDirectives(_createVNode(Modal, {
                    closeModal: _unref(closeInitModal),
                    "base-url": _unref(lintBaseUrl),
                    "client-id": props.clientId,
                    "max-text-length": _unref(maxTextLength),
                    onUpdate: updateText
                }, null, 8, ["closeModal", "base-url", "client-id", "max-text-length"]), [
                    [_vShow, _unref(initModal)]
                ]),
                _withDirectives(_createVNode(ArrangeModal, {
                    closeModal: _unref(closeArrangeModal),
                    "base-url": _unref(lintBaseUrl),
                    "client-id": props.clientId,
                    "max-text-length": _unref(maxTextLength),
                    onUpdate: updateText
                }, null, 8, ["closeModal", "base-url", "client-id", "max-text-length"]), [
                    [_vShow, _unref(arrangeModal)]
                ]),
                _hoisted_29
            ], 64));
        };
    }
});
